import Typography from "@mui/material/Typography";
import type { SearchTemplateValue, User } from "../../api/";
import { AttentionBadge } from "./AttentionBadge";
import { BaseTodoBox } from "./BaseTodoBox";
import { setClassNamesByCount } from "./utils";

export const Followups = ({
	followups,
	activeUser,
	readOnly = false,
}: {
	followups: SearchTemplateValue;
	activeUser: User;
	readOnly?: boolean;
}) => {
	return (
		<BaseTodoBox
			className={setClassNamesByCount(followups.count)}
			title={
				<AttentionBadge
					count={followups.count}
					title="Followup with others that have asked something"
					readOnly={readOnly}
					url={followups.url}
				/>
			}
			description={
				<Typography variant="body1" component="div" color="textPrimary">
					Respond or mark as done
				</Typography>
			}
			to={followups.url}
			readOnly={readOnly}
		/>
	);
};
